/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:999px){.mainContent.noheaderExpand[_ngcontent-%COMP%]{padding-top:45px!important}.mainContent.mainContentMob[_ngcontent-%COMP%]{padding-top:40px!important}.mainContent.mainContentWithSAB[_ngcontent-%COMP%]{padding-top:0!important}}@media (min-width:985px){.mainContent.draftPage[_ngcontent-%COMP%]{padding-top:0!important}}.mainContentWithSAB[_ngcontent-%COMP%]{padding-top:0!important}  ngx-spinner{color:var(--text-color)!important}"];
export { styles as styles };
